import { getEnvironmentVariable } from '@didaskill/utils/web';

export default {
  app: {
    name: 'eversity/mentor',
    env: getEnvironmentVariable('ENVIRONMENT'),
  },

  sentry: {
    dsn: getEnvironmentVariable('MENTOR_WEB_SENTRY_DSN'),
    env: getEnvironmentVariable('ENVIRONMENT'),
    release: `mentor-web@${process.env.BUILD_VAR_SENTRY_RELEASE}`,
    enabled: getEnvironmentVariable('MENTOR_WEB_SENTRY_ENABLED', {
      transform: (v) => v === 'true',
      defaultValue: getEnvironmentVariable('SENTRY_ENABLED', {
        transform: (v) => v === 'true',
        defaultValue: true,
      }),
    }),
  },
} as const;
